import React from 'react';
import { Stack, Chip } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

/**
 * Renders a list of chips with delete. items: array of strings (label) or { label, key }.
 * onDelete(index) when a chip is removed.
 */
export default function ChipList({ items, onDelete, size = 'small', variant = 'outlined' }) {
  if (!items?.length) return null;
  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {items.map((item, idx) => {
        const label = typeof item === 'string' ? item : item?.label ?? '';
        const key = typeof item === 'string' ? item : item?.key ?? `${label}-${idx}`;
        return (
          <Chip
            key={key}
            label={label}
            onDelete={() => onDelete(idx)}
            deleteIcon={<DeleteIcon />}
            size={size}
            variant={variant}
          />
        );
      })}
    </Stack>
  );
}
